import React, { useEffect } from 'react';
import { useWebSocketStore } from '../../store/websocketStore';

import { useTranslation } from 'react-i18next';

interface WebSocketConnectionProps {
  url?: string;
  showStatus?: boolean;
}

export const WebSocketConnection = ({
  url = `wss://${process.env.API_URL || window.location.host}/wss-api`,
  showStatus = false,
}: WebSocketConnectionProps) => {
  const { t } = useTranslation('pleri/pages');
  const connect = useWebSocketStore((state) => state.connect);
  const disconnect = useWebSocketStore((state) => state.disconnect);
  const status = useWebSocketStore((state) => state.status);

  useEffect(() => {
    connect(url);
    return () => {
      disconnect();
    };
  }, [connect, disconnect, url]);

  // Component can be invisible or show connection status if needed
  if (!showStatus) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 rounded-full bg-gray-800 px-3 py-1 text-sm text-white opacity-75">
      {t('webSocket', { status })}
    </div>
  );
};
